import { AppDispatch, RootState } from '../../state';
import { refreshAccessToken } from './refreshAccessToken';
import { base64ToUtf8 } from '../utils';

function isTokenExpired(token: string | null): boolean {
    if (!token) return true;
    try {
        const [, payload] = token.split('.');
        const { exp } = JSON.parse(base64ToUtf8(payload));
        const earlyExpiryMs = 60_000;
        return Date.now() > exp * 1000 - earlyExpiryMs;
    } catch {
        return true;
    }
}

let refreshPromise: Promise<string> | null = null;

export async function getValidAccessToken(dispatch: AppDispatch, getState: () => RootState): Promise<string> {
    const { accessToken } = getState().auth;
    if (accessToken && !isTokenExpired(accessToken)) {
        return accessToken;
    }

    if (!refreshPromise) {
        refreshPromise = dispatch(refreshAccessToken() as any)
            .unwrap()
            .finally(() => {
                refreshPromise = null;
            });
    }

    return refreshPromise;
}
